"use client"
import React from "react";
import styles from "./TitleText.module.css";
import scroll_icon from "../assets/Icon/Scroll_Icon.png";
import { useTranslation } from "react-i18next";
import Image from "next/image"
const TitleText = ({
    titleTextInfo,
    bottomTextInfo,
    topTextInfo,
    scrollicon,
}) => {
    const { t } = useTranslation();
    return (
        <div className={styles.title}>
            <h2 className={`${styles.top__description}`} style={{ color: topTextInfo && topTextInfo.color ? topTextInfo.color : "" }}>
                {topTextInfo && topTextInfo.textKey && t(topTextInfo.textKey)}
            </h2>
            <h1 className={`${styles.main}`} style={{ color: titleTextInfo && titleTextInfo.color ? titleTextInfo.color : "" }}>
                {titleTextInfo && titleTextInfo.textKey && t(titleTextInfo.textKey)}
            </h1>
            <h2 className={`${styles.bottom__description}`} style={{ color: bottomTextInfo && bottomTextInfo.color ? bottomTextInfo.color : "" }}>
                {bottomTextInfo && bottomTextInfo.textKey && t(bottomTextInfo.textKey)}
            </h2>
             {/* 스크롤 버튼 */}
             <div className={styles.scroll__btn} style={scrollicon || {}}>
                <Image loading="eager" src={scroll_icon} className={styles.scroll__btn__image} alt="scroll icon" />
            </div>
        </div>
    );
}

export default TitleText;